import React, { useEffect, useState } from "react";
import Button from "components/CustomButtons/Button.js";
import {
  AccountBalanceWalletSharp,
  CloudUpload,
  Delete,
  Edit,
  LinkSharp,
  PlayArrow,
  SyncAltSharp,
} from "@material-ui/icons";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import {
  approveErc20,
  claimFee,
  claimFeeOld,
  deploy,
  getRewardDetail,
} from "./staking";
import { ethers } from "ethers";
import { stakingService } from "../../services/stakingService";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { abi as erc20Abi } from "../../contracts/ERC20Mock.json";
import { CircularProgress } from "@material-ui/core";

const chainPrc = process.env.REACT_APP_CHAIN_PRC;
const STAKING_LINK = process.env.REACT_APP_STAKING_LINK;
const QUERY = `chain=${process.env.REACT_APP_NETWORK}`.toLowerCase();

export default function ActionNormal({ item, onCallNetwork, refresh }) {
  const [isShowClaimFee, setIsShowClaimFee] = useState(false);
  const [isShowStart, setIsShowStart] = useState(false);
  const [poolBalance, setPoolBalance] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isModalDel, setIsModalDel] = useState(false);

  async function fetchPoolBalance() {
    if (!item?.address) return;
    const provider = new ethers.providers.JsonRpcProvider(chainPrc);
    console.log(item.address);
    const balance = await provider.getBalance(item.address);
    console.log(+ethers.utils.formatEther(balance));
    setPoolBalance(+ethers.utils.formatEther(balance));
  }

  async function handleDelete() {
    if (!confirm("Delete staking ?")) return;
    await stakingService.remove(item._id);
    refresh();
  }

  async function syncToDatabase() {
    setLoading(true);
    try {
      const { rewardPerWeek, weeks, periodFinish, paused } =
        await getRewardDetail(item.address, item.chainId);
      if (rewardPerWeek == 0) {
        alert("Reward per week is 0");
        return;
      }
      console.log({ rewardPerWeek, weeks, periodFinish, paused });
      await stakingService.update(item._id, {
        rewardPerWeek,
        weeks,
        startTime: Math.floor(Date.now() / 1000),
        periodFinish,
        paused,
      });
      alert("Sync success");
      refresh();
    } catch (error) {
      console.log({ error });
      alert("Error when update staking");
    } finally {
      setLoading(false);
    }
  }

  async function syncToDatabaseOld() {
    setLoading(true);
    try {
      const rewardPerWeek = prompt("Reward per week (Formated value)");
      const weeks = prompt("Weeks");
      // confirm
      const cf = confirm(`Reward per week: ${rewardPerWeek}, Weeks: ${weeks}`);
      if (!cf) return;

      await stakingService.update(item._id, {
        rewardPerWeek,
        weeks,
        startTime: Math.floor(Date.now() / 1000),
      });
      alert("Sync success");
      refresh();
    } catch (error) {
      console.log(error);
      alert("Error when update staking");
    } finally {
      setLoading(false);
    }
  }

  async function runDeploy() {
    const stakingChainId = item.chainId;
    localStorage.setItem("rowChainIdTemp", stakingChainId);
    onCallNetwork(
      "Deploy staking pool",
      async (signer) => {
        const collections = item.collections.map((c) => c.address);

        if (!ethers.utils.isAddress(item.rewardCoin)) {
          alert("Reward coin not available");
          return {};
        }

        const invalid = collections.find((c) => !ethers.utils.isAddress(c));

        if (invalid) {
          alert("Invalid collection address");
          return {};
        }
        return deploy(signer, {
          coinAddress: item.rewardCoin,
          collections: collections,
          ratio: item.collections.map((c) => c.ratio),
          booster: item.booster,
          boosterRatio: item.boosterRatio,
        });
      },
      async (data) => {
        return stakingService.update(item._id, {
          address: data.address,
        });
      }
    );
  }

  function runClaimFee() {
    setIsShowClaimFee(false);
    onCallNetwork(
      "Claim Fee",
      async (signer) => {
        return item.stakingV2
          ? claimFee(signer, { stakingAddress: item.address })
          : claimFeeOld(signer, { stakingAddress: item.address });
      },
      () => {}
    );
  }

  useEffect(() => {
    fetchPoolBalance();
  }, [item, isShowClaimFee]);

  return (
    <>
      {item.stakingV2 ? (
        <div className="actions-right">
          <Link to={`/admin/staking/${item._id}/${item.type}`}>
            <Button justIcon round simple color="primary" className="edit">
              <Edit />
            </Button>
          </Link>

          {!["not_deployed"].includes(item.status) && (
            <Button
              justIcon
              round
              simple
              color="success"
              onClick={syncToDatabase}
            >
              {loading ? <CircularProgress size={24} /> : <SyncAltSharp />}
            </Button>
          )}

          {!["not_deployed"].includes(item.status) && !item.canBoost && (
            <Button
              justIcon
              round
              simple
              color="success"
              onClick={() => setIsShowClaimFee(true)}
            >
              <AccountBalanceWalletSharp />
            </Button>
          )}

          {["not_deployed"].includes(item.status) && (
            <Button
              justIcon
              round
              simple
              color="success"
              onClick={() => runDeploy()}
            >
              <CloudUpload />
            </Button>
          )}

          {["not_started", "finished"].includes(item.status) && (
            <Button
              justIcon
              round
              simple
              color="success"
              onClick={() => setIsShowStart(true)}
            >
              <PlayArrow />
            </Button>
          )}

          <a
            href={`${STAKING_LINK}/pools/v2/${item._id}/stakingPools?${QUERY}`}
            target="_blank"
            rel="noreferrer"
          >
            <Button justIcon round simple color="success" className="edit">
              <LinkSharp />
            </Button>
          </a>

          <Button
            justIcon
            round
            simple
            color="danger"
            onClick={() => {
              handleDelete(item._id);
            }}
          >
            <Delete />
          </Button>
        </div>
      ) : (
        <div className="actions-right">
          {!["not_deployed"].includes(item.status) && (
            <Button
              justIcon
              round
              simple
              color="success"
              onClick={syncToDatabaseOld}
            >
              {loading ? <CircularProgress size={24} /> : <SyncAltSharp />}
            </Button>
          )}

          {["finished"].includes(item.status) && (
            <Button
              justIcon
              round
              simple
              color="success"
              onClick={() => setIsShowStart(true)}
            >
              <PlayArrow />
            </Button>
          )}

          {!["not_deployed"].includes(item.status) && (
            <Button
              justIcon
              round
              simple
              color="success"
              onClick={() => setIsShowClaimFee(true)}
            >
              <AccountBalanceWalletSharp />
            </Button>
          )}
          <a
            href={`${STAKING_LINK}/pools/v2/${item._id}/stakingPools`}
            target="_blank"
            rel="noreferrer"
          >
            <Button justIcon round simple color="success" className="edit">
              <LinkSharp />
            </Button>
          </a>

          <Button
            justIcon
            round
            simple
            color="danger"
            onClick={() => {
              handleDelete(item._id);
            }}
          >
            <Delete />
          </Button>
        </div>
      )}

      <Dialog open={isShowStart} onClose={() => setIsShowStart(false)}>
        {item.stakingV2 ? (
          <StartPool staking={item} />
        ) : (
          <StartPoolOld
            staking={item}
            onCallNetwork={onCallNetwork}
            onClose={() => setIsShowStart(false)}
            onOpen={() => setIsShowStart(true)}
          />
        )}
      </Dialog>

      <Dialog open={isShowClaimFee} onClose={() => setIsShowClaimFee(false)}>
        <DialogContent>
          Current balance: ${poolBalance}{" "}
          {process.env.REACT_APP_NETWORK === "polygon" ? "POL" : "CRO"}
        </DialogContent>
        <DialogActions>
          <div className="p-2">
            <Button color="success" onClick={() => runClaimFee()}>
              Claim
            </Button>
          </div>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isModalDel}
        onClose={() => setIsModalDel(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm remove staking"}
        </DialogTitle>
        <DialogActions>
          <Button onClick={() => setIsModalDel(false)} color="transparent">
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleDelete(item?._id);
            }}
            color="success"
          >
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

ActionNormal.propTypes = {
  item: PropTypes.any,
  onCallNetwork: PropTypes.func,
  refresh: PropTypes.func,
};

function StartPool({ staking }) {
  const [previewDuration, setPreviewDuration] = useState(1);
  const [previewReward, setPreviewReward] = useState(0);
  const [rewardCoinDecimals, setRewardCoinDecimals] = useState(0);

  async function fetchDecimals() {
    const provider = new ethers.providers.JsonRpcProvider(chainPrc);
    const contract = new ethers.Contract(
      staking.rewardCoin,
      erc20Abi,
      provider
    );
    const decimals = await contract.decimals();
    setRewardCoinDecimals(decimals);
  }

  useEffect(() => {
    if (!staking?.rewardCoin) return 0;
    try {
      fetchDecimals();
    } catch (error) {
      console.log(error);
      alert("Error when fetch reward coin decimals");
    }
  }, [staking]);

  return (
    <DialogContent>
      <h5>Start staking when not started or finished</h5>
      <p>
        Address: <b>{staking?.address}</b>
      </p>
      <div style={{ marginBottom: 5 }}>
        <label style={{ marginRight: 5 }}>Durations(weeks)</label>
        <input
          placeholder="2 (weeks)"
          value={previewDuration}
          onChange={(e) => setPreviewDuration(e.target.value)}
        />
      </div>
      <div style={{ marginBottom: 5 }}>
        <label style={{ marginRight: 5 }}>Total reward </label>
        <input
          placeholder="1000"
          value={previewReward}
          onChange={(e) => setPreviewReward(e.target.value)}
        />
      </div>

      <div>
        <label>Reward per week</label>
        <p>{previewReward / previewDuration}</p>
      </div>

      <br />
      <ol>
        <li>
          <h6>Set duration: </h6>
          <p>
            Go to contract on cronoscan and call{" "}
            <strong>setRewardsDuration</strong>
          </p>
          <p>
            {" "}
            Params: <br />
            <strong>_rewardsDuration</strong> =
            {previewDuration * 7 * 24 * 60 * 60} (s)
          </p>
        </li>
        <li>
          <h6>Transfer reward coin to staking contract: </h6>
          <p>
            Transfer{" "}
            <strong>
              {previewReward} {staking?.rewardCoinName}
            </strong>{" "}
            to staking contract
          </p>
        </li>
        <li>
          <h6>Start staking: </h6>
          <p>
            {" "}
            Go to contract on cronoscan and call{" "}
            <strong>notifyRewardAmount</strong>
          </p>
          <p>
            {" "}
            Params: <br />
            <strong>reward</strong> ={" "}
            {(+previewReward * 10 ** rewardCoinDecimals).toLocaleString(
              "fullwide",
              {
                useGrouping: false,
              }
            )}
          </p>
        </li>
        <li>
          <h6> Click on sync to database Icon </h6>
        </li>
      </ol>
    </DialogContent>
  );
}

StartPool.propTypes = {
  staking: PropTypes.any,
};

function StartPoolOld({ staking, onCallNetwork, onClose, onOpen }) {
  const [previewDuration, setPreviewDuration] = useState(1);
  const [previewReward, setPreviewReward] = useState(0);
  const [rewardCoinDecimals, setRewardCoinDecimals] = useState(0);

  async function fetchDecimals() {
    const provider = new ethers.providers.JsonRpcProvider(chainPrc);
    const contract = new ethers.Contract(
      staking.rewardCoin,
      erc20Abi,
      provider
    );
    const decimals = await contract.decimals();
    setRewardCoinDecimals(decimals);
  }

  function runApproveErc20(amount) {
    onClose();
    onCallNetwork(
      "Approve coin",
      async (signer) => {
        return approveErc20(signer, {
          poolAddress: staking.address,
          coinAddress: staking.rewardCoin,
          amount: ethers.utils.parseUnits(
            amount.toString(),
            rewardCoinDecimals
          ),
        });
      },
      () => {
        alert("Approve success");
        onOpen();
      }
    );
  }

  useEffect(() => {
    if (!staking?.rewardCoin) return 0;
    try {
      fetchDecimals();
    } catch (error) {
      console.log(error);
      alert("Error when fetch reward coin decimals");
    }
  }, [staking]);

  return (
    <DialogContent>
      <h5>
        Restart staking <strong>V1</strong>
      </h5>
      <p>
        Address: <b>{staking?.address}</b>
      </p>
      <div style={{ marginBottom: 5 }}>
        <label style={{ marginRight: 5 }}>Durations(weeks)</label>
        <input
          placeholder="2 (weeks)"
          value={previewDuration}
          onChange={(e) => setPreviewDuration(e.target.value)}
        />
      </div>
      <div style={{ marginBottom: 5 }}>
        <label style={{ marginRight: 5 }}>Total reward </label>
        <input
          placeholder="1000"
          value={previewReward}
          onChange={(e) => setPreviewReward(e.target.value)}
        />
      </div>

      <div>
        <label>Reward per week</label>
        <p>{previewReward / previewDuration}</p>
      </div>

      <br />
      <ol>
        <li>
          <h6>Update all user rewards</h6>
          <div>
            Call <strong>updateAllUserReward</strong> for{" "}
            <strong>{staking.collections.length}</strong> collection:
            {staking?.collections.map((c, i) => (
              <div key={i}>
                <strong>{c.name}</strong> - {c.address}
              </div>
            ))}
          </div>
        </li>

        <li>
          <h6>Approve erc20</h6>
          <button onClick={() => runApproveErc20(+previewReward)}>
            {" "}
            Approve{" "}
          </button>
        </li>

        <li>
          <h6>
            Call <strong>extend</strong> function
          </h6>
          <p>
            {" "}
            Go to contract on cronoscan and call <strong>extend</strong>
          </p>
          <p>
            {" "}
            Params: <br />
            <strong>_rewardPerWeek</strong> ={" "}
            {(
              (+previewReward / +previewDuration) *
              10 ** rewardCoinDecimals
            ).toLocaleString("fullwide", { useGrouping: false })}
            <br />
            <strong>_weeks</strong> = {+previewDuration}
          </p>
        </li>
        <li>
          <h6> Click on sync to database Icon </h6>
        </li>
      </ol>
    </DialogContent>
  );
}

StartPoolOld.propTypes = {
  staking: PropTypes.any,
  onCallNetwork: PropTypes.func,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
};
